/**
 * Product: The Heirloom Pendant
 * Handles: nav scroll, variant swap, metal gradient SVG swap,
 *          font preview, initial update, gallery thumbs, cart submission.
 */
(function () {
  'use strict';

  /* ── Nav scroll behavior (matches homepage) ── */
  var mainNav = document.getElementById('mainNav');
  if (mainNav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        mainNav.classList.add('scrolled');
      } else {
        mainNav.classList.remove('scrolled');
      }
    }, { passive: true });
    // Check on load
    if (window.scrollY > 40) mainNav.classList.add('scrolled');
  }

  /* ── Constants ── */
  var ALLOWED_FONTS = ['Old English', 'Colonna MT', 'Edwardian Script', 'Typewriter'];

  var metalSets = {
    '105': { top: '#F5D88A', mid: '#D4A85C', bottom: '#A07835', edge: '#E8C893', cmid: '#B8956A' },
    '102': { top: '#F2C5B0', mid: '#D89A82', bottom: '#A86B58', edge: '#E8B8A0', cmid: '#B88572' },
    '106': { top: '#F5F5F2', mid: '#C8C8C2', bottom: '#909088', edge: '#E0E0DA', cmid: '#A8A8A2' }
  };

  /* ── Variant data (includes featured_image URLs) ── */
  var variantData = [];
  try {
    variantData = JSON.parse(document.getElementById('hp-variant-data').textContent);
  } catch(e) {}

  /* ── DOM refs ── */
  var variantInput   = document.getElementById('hp-variant-id');
  var priceDisplay   = document.getElementById('hp-price-display');
  var ctaPrice       = document.getElementById('hp-cta-price');
  var metalDisplay   = document.getElementById('hp-metal-display');
  var initialSelect  = document.getElementById('hp-initial-select');
  var initialDisplay = document.getElementById('hp-initial-display');
  var previewGlyph   = document.getElementById('hp-preview-glyph');
  var fontInput      = document.getElementById('hp-font-input');
  var fontDisplay    = document.getElementById('hp-font-display');
  var form           = document.getElementById('hp-product-form');
  var ctaBtn         = document.getElementById('hp-add-to-cart');

  /* ── Metal selector ── */
  var metalBtns = document.querySelectorAll('.hp-metal');

  function applyMetalSet(setKey) {
    var s = metalSets[setKey];
    if (!s) return;
    document.querySelectorAll('.metal-top').forEach(function (el) { el.setAttribute('stop-color', s.top); });
    document.querySelectorAll('.metal-mid').forEach(function (el) { el.setAttribute('stop-color', s.mid); });
    document.querySelectorAll('.metal-bottom').forEach(function (el) { el.setAttribute('stop-color', s.bottom); });
    document.querySelectorAll('.chain-edge').forEach(function (el) { el.setAttribute('stop-color', s.edge); });
    document.querySelectorAll('.chain-mid').forEach(function (el) { el.setAttribute('stop-color', s.cmid); });
  }

  metalBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      metalBtns.forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');

      variantInput.value = btn.dataset.variantId;
      priceDisplay.textContent = btn.dataset.price;
      ctaPrice.textContent = btn.dataset.price;
      metalDisplay.textContent = btn.dataset.name;

      applyMetalSet(btn.dataset.set);

      // Swap main image to variant's featured image
      var vid = parseInt(btn.dataset.variantId, 10);
      var variant = variantData.find(function (v) { return v.id === vid; });
      if (variant && variant.featured_image) {
        var firstSlide = document.querySelector('.hp-main-image .hp-slide[data-slide="0"]');
        if (firstSlide) {
          var img = firstSlide.querySelector('img');
          if (img) {
            img.src = variant.featured_image;
          } else {
            // Replace SVG placeholder with real image
            firstSlide.innerHTML = '<img src="' + variant.featured_image + '" alt="' + variant.title + '" width="900">';
          }
          // Show first slide
          document.querySelectorAll('.hp-main-image .hp-slide').forEach(function (s) { s.classList.remove('active'); });
          firstSlide.classList.add('active');
          document.querySelectorAll('.hp-thumb').forEach(function (t) { t.classList.remove('active'); });
          var firstThumb = document.querySelector('.hp-thumb[data-slide="0"]');
          if (firstThumb) firstThumb.classList.add('active');
        }
      }

      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', btn.dataset.variantId);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* ── Initial selector ── */
  function setEngravedLetter(letter) {
    var l = letter.toUpperCase();
    if (initialDisplay) initialDisplay.textContent = l;
    if (previewGlyph) previewGlyph.textContent = l;

    // Update all SVG engraved letters
    var targets = document.querySelectorAll(
      '#engraved-letter, .engraved-letter-2, .engraved-letter-3, .engraved-letter-4, .hp-thumb-letter'
    );
    targets.forEach(function (el) { el.textContent = l; });

    // Update font picker preview glyphs
    document.querySelectorAll('.hp-font-opt .hp-glyph').forEach(function (el) {
      el.textContent = l;
    });
  }

  if (initialSelect) {
    initialSelect.addEventListener('change', function (e) {
      setEngravedLetter(e.target.value);
    });
  }

  /* ── Font selector ── */
  var fontBtns = document.querySelectorAll('.hp-font-opt');

  fontBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      fontBtns.forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');

      var fontName = btn.dataset.name;
      var fontCss = btn.dataset.fontCss;

      if (fontDisplay) fontDisplay.textContent = fontName;
      if (fontInput) fontInput.value = fontName;
      if (previewGlyph) previewGlyph.style.fontFamily = fontCss;
    });
  });

  /* ── Gallery thumbs ── */
  var thumbs = document.querySelectorAll('.hp-thumb');
  var slides = document.querySelectorAll('.hp-main-image .hp-slide');

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      slides.forEach(function (s) { s.classList.remove('active'); });
      t.classList.add('active');
      var idx = t.dataset.slide;
      var target = document.querySelector('.hp-main-image .hp-slide[data-slide="' + idx + '"]');
      if (target) target.classList.add('active');

      // On mobile, scroll the main image into view
      if (window.innerWidth <= 720) {
        var mainImg = document.querySelector('.hp-main-image');
        if (mainImg) mainImg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });

  /* ── Add to cart handled by Shopify theme's built-in cart.js ── */

  /* ── Deep-link: select variant from URL param on load ── */
  (function () {
    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    if (!vid) return;
    metalBtns.forEach(function (btn) {
      if (btn.dataset.variantId === vid) {
        btn.click();
      }
    });
  })();

  /* ── Chain upgrade inquiry toggle ── */
  var chainLinks = document.querySelectorAll('.hp-chain-inquiry-link');
  var chainForm = document.getElementById('hp-chain-inquiry');
  var chainClose = document.querySelector('.hp-chain-inquiry-close');

  chainLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (chainForm) {
        chainForm.style.display = 'block';
        chainForm.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });
  if (chainClose && chainForm) {
    chainClose.addEventListener('click', function () {
      chainForm.style.display = 'none';
    });
  }

})();
